import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import List from '@material-ui/core/List';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import ACButton from '../../atoms/ACButton';
import Clue from '../sparks/Clue';
import SetClue from '../sparks/SetClue';
import { getUIElementsWithMedias, getUIElementType, getUIElement } from '../../common/global';

import styles from './Clues.module.scss';
export default class Clues extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      clue: {},
      updateData: {},
    };
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;

    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
  }

  updateMedia(media) {
    const { clue = {} } = cloneDeep(this.state);
    const { name, url } = media;
    let uiElement = {};
    let uiEleMedia = {};
    switch (name) {
      case 'introduction':
        uiElement = getUIElement(clue.uiElements, getUIElementType().introduction);
        break;
      case 'clueHard':
        uiElement = getUIElement(clue.uiElements, getUIElementType().clueHard);
        break;
      case 'clueEasy':
        uiElement = getUIElement(clue.uiElements, getUIElementType().clueEasy);
        break;
      case 'hint':
        uiElement = getUIElement(clue.uiElements, getUIElementType().hint);
        break;
      default:
        break;
    }
    uiEleMedia = uiElement.media || {};
    uiEleMedia.url = url;
    uiElement.media = uiEleMedia;
    this.updateClueData(cloneDeep(uiElement));
  }

  updateClueData(uiElement) {
    const { clue = {}, updateData } = cloneDeep(this.state);
    let { uiElements = [] } = clue;
    const { type = '', subType = '' } = uiElement;
    uiElements = uiElements ? uiElements : [];
    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) {
        return ele.type === type && ele.subType === subType;
      } else return ele.type === type && isEmpty(ele.subType);
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);

    clue.uiElements = uiElements;
    updateData.uiElements = uiElements;
    this.setState({ clue, updateData });
  }

  onOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  onCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  onSelectClue = (clue) => {
    this.setState({ clue });
    this.onOpenModal();
  };

  onChangeClue = (name, value) => {
    const { clue = {}, updateData } = cloneDeep(this.state);
    clue[name] = value;
    updateData[name] = value;
    this.setState({ clue, updateData });
  };

  checkClueValidity = (clueName) => {
    const regex = /^[A-Za-z0-9\s-'+&ÅåÄäÖöÆæØø]+$/;
    const isValid = regex.test(clueName);
    if (!isValid || isEmpty(clueName)) {
      return false;
    } else {
      return true;
    }
  };

  onSaveClue = () => {
    const { clue, updateData } = cloneDeep(this.state);
    let saveClue = true;
    if (!isEmpty(clue) && clue.id !== '-1') updateData.id = clue.id;
    const { uiElements = [] } = updateData;
    if (!isEmpty(uiElements)) {
      updateData.uiElements.forEach((element) => {
        if (
          element.type === 'clue-hard' &&
          element?.solvable &&
          !this.checkClueValidity(element.solvableClue)
        ) {
          saveClue = false;
        }
      });
      updateData.uiElements = getUIElementsWithMedias(uiElements);
    }
    if (saveClue) {
      this.props.onSaveClueFunc(updateData);
      this.setState({ clue: {}, updateData: {} });
      this.onCloseModal();
    }
  };

  onAddClue = () => {
    const clue = { id: '-1' };
    this.setState({ clue });
    this.onOpenModal();
  };

  render() {
    const { clues = [], uploadMediaFunc, spark } = this.props;
    const { isModalOpen = false, clue = {} } = cloneDeep(this.state);
    return (
      <div>
        <div className={styles.title}>
          Available Clues
          <ACButton
            text={'Add'}
            icon={<AddCircleOutlineIcon />}
            iconLast={true}
            onClickFunc={this.onAddClue}
          />
        </div>

        {!isEmpty(clues) && (
          <List className={styles.clueList}>
            {clues?.map((clue) => {
              return (
                <Clue
                  key={`clue-${clue.id || '-1'}`}
                  clue={clue}
                  onClickClueFunc={this.onSelectClue}
                />
              );
            })}
          </List>
        )}

        <SetClue
          clue={clue}
          isModalOpen={isModalOpen}
          onCloseFunc={this.onCloseModal}
          onChangeClueFunc={this.onChangeClue}
          onSaveClueFunc={this.onSaveClue}
          uploadMediaFunc={uploadMediaFunc}
          spark={spark}
        />
      </div>
    );
  }
}
